import React, { useState } from "react";
import styles from './reviewCriteria.module.scss';
import { CustomButton } from '../../../../shared/customButton';
import { CustomStarTextField } from '../../../../shared/customStarTextField';
import { Formik, FieldArray } from 'formik';
import { Col, Row, Form, Card, Button, Accordion, Tab, Tabs } from 'react-bootstrap';
import StarRating from '../../../../shared/rate';
import { CustomAlertBox } from '../../../../shared/customAlertBox';
import * as yup from 'yup';

const AddReviewCriteria = (props) => {

    yup.addMethod(yup.array, 'unique', function (message, mapper = a => a) {
        return this.test('unique', message, function (list) {
            return list.length === new Set(list.map(mapper)).size;
        });
    })
    const schema = yup.object({
        reviewCriteria: yup.array().of(
            yup.object().shape({
                label: yup.string().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('required'),
            })
        )
            .unique('Duplicate review criterion', r => r.label)
            .min(1, 'At least one review criterion is required. Enter the review criterion and click "Add" button.').required('Required'),
        reviewCriteriaToBeAdded: yup.string().when('reviewCriteria', {
            is: (reviewCriteria) => (reviewCriteria && reviewCriteria.length > 0), then: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').test('duplicate subject check', 'Duplicate review criterion', function (item) {
                if ((this.parent.reviewCriteria.findIndex(obj => obj.label === item)) != -1) {
                    return false;
                } else {
                    return true;
                }
            }), otherwise: yup.string()
        }),
    });
    const onSubmit = (values) => {
        props.setAddReviewCriteria(values);
        props.nextPage(6)
    }

    const addReviewCriteria = (e, values, setValues) => {

        const reviewCriteria = [...values.reviewCriteria];

        let newReviewCriteria = {
            label: ''
        }

        reviewCriteria.push(newReviewCriteria);
        setValues({ ...values, reviewCriteria });

    }

    const removeAddiionalReviewCriteria = (e, id, values, setValues) => {
        const reviewCriteria = [...values.reviewCriteria];
        if (reviewCriteria.length !== 0) {
            let newArray = reviewCriteria.filter(function (obj, index) {
                return index !== id;
            });
            setValues({ ...values, reviewCriteria: newArray });
        }
    }

    const setObjectArray = (values) => {
        const data = {
            label: values.reviewCriteriaToBeAdded
        }
        if ((values.reviewCriteriaToBeAdded).length > 0) {
            values.reviewCriteria.push(data);
        }
    }
    return (
        <div>
            <Formik
                enableReinitialize
                validationSchema={schema}
                onSubmit={(values) => onSubmit(values)}
                initialValues={{ reviewCriteria: props.pipelineValues.reviewCriteria }}
            >
                {({
                    values,
                    errors,
                    setFieldValue,
                    touched,
                    setValues,
                    handleChange,
                    handleSubmit,
                    submitCount,
                }) => (
                    <div>
                        <Form noValidate onSubmit={handleSubmit}>
                            <div className={styles.alertDiv}>
                                <CustomAlertBox alertType="warningAlert" alertBodyText="Add a list of criteria to evaluate candidates. Reviewers will rate candidates on these criteria" />
                            </div>
                            <div>
                                <p className={styles.subTopics}>Review candidates base on skills</p>
                                <p className={styles.reviewCriteriaErrorMsg}>{(errors && errors.reviewCriteria && !Array.isArray(errors.reviewCriteria)) && errors.reviewCriteria}</p>

                                <FieldArray name="reviewCriteria">
                                    {() => (values.reviewCriteria && values.reviewCriteria.map((reviewCriteria, i) => {


                                        const reviewCriteriaErrors = ((errors.reviewCriteria?.length) && (errors.reviewCriteria[i])) || {};
                                        const reviewCriteriaTouched = ((touched.reviewCriteria?.length) && (touched.reviewCriteria[i])) || {};
                                        return (
                                            <div key={i}>
                                                <CustomStarTextField
                                                    keyValue={i}
                                                    classLabel="defaultLabel"
                                                    controlId={`reviewCriteria.${i}`}
                                                    type="text"
                                                    value={(values && values.reviewCriteria && values.reviewCriteria[i]) && values.reviewCriteria[i].label}
                                                    handleOnChange={handleChange}
                                                    name={`reviewCriteria.${i}.label`}
                                                    classType="defaultTextBox"
                                                    onCancelClick={(e) => removeAddiionalReviewCriteria(e, i, values, setValues)}
                                                    errorMessage={(errors && errors.reviewCriteria && errors.reviewCriteria[i]) && errors.reviewCriteria[i].label}
                                                    isInvalid={(errors && errors.reviewCriteria && errors.reviewCriteria[i]) ? true : false}
                                                    isCancelable={true}
                                                />
                                            </div>
                                        );
                                    }))}
                                </FieldArray>
                                <CustomButton
                                    id="add_reviewCriteria"
                                    buttonType="button"
                                    label="Add New Criteria"
                                    type="secondaryBtn"
                                    handleClick={(e) => addReviewCriteria(e, values, setValues)}
                                    frontIcon={
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                            <path d="M10 4.66667V16.3333M4.16669 10.5H15.8334"  stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    }

                                />
                            </div>
                            <hr className={styles.dividerLine} />
                            <Row className="mt-3 mb-3 d-flex flex-row-reverse">
                                <div className={styles.navigateBtnCol}>
                                    <CustomButton
                                        id="pipeline_additional_detail_confirm"
                                        buttonType="submit"
                                        label="Next"
                                        type="primaryBtn"
                                    />
                                </div>
                                <div className={styles.navigateBtnCol}>
                                    <CustomButton
                                        id="pipeline_additional_detail_cancel"
                                        buttonType="button"
                                        label="Back"
                                        type="defaultBtn"
                                        handleClick={() => props.previousPage(4)}
                                    />
                                </div>

                            </Row>
                        </Form>
                    </div>
                )}
            </Formik>
        </div>
    );
};
export default AddReviewCriteria;